/*
 * @Author: Mufaddal Jamali
 * @Date: 2020-03-16 15:48:27
 * @Last Modified by:   Mufaddal Jamali
 * @Last Modified time: 2020-03-16 15:48:27
 */

import React, { Component } from "react";
import $ from "jquery";

const PrimaryButton = (props) => {
  let nextAndBackBtn = window["app-config"].ui.header.backGroundColor;
  $(document).ready(function () {
    $(".primaryBtn").css("background-color", props.bgColor);
    $(".primaryBtn").css("border-color", props.bgColor);
  });
  return (
    <div className="primaryBtn" onClick={props.onClick}>
      <a>{props.children}</a>
    </div>
  );
};

export default PrimaryButton;
